import { Badge } from "@/components/ui/badge";

// ---------------------------------------------------------------------------
// Source status color maps — single source of truth
// ---------------------------------------------------------------------------

export const statusColors: Record<string, string> = {
  ready: "bg-mark-helps/8 text-finding-helps",
  ready_unverified: "bg-mark-important/8 text-severity-important",
  processing: "bg-primary/10 text-primary-ink",
  pending: "bg-mark-important/8 text-severity-important",
  error: "bg-mark-critical/8 text-severity-critical",
  stale: "bg-muted text-muted-foreground",
};

export const statusLabels: Record<string, string> = {
  ready: "Ready",
  ready_unverified: "Unverified",
  processing: "Processing",
  pending: "Pending",
  error: "Error",
  stale: "Stale",
};

export const statusDotColors: Record<string, string> = {
  ready: "bg-mark-helps",
  ready_unverified: "bg-mark-important",
  processing: "bg-primary",
  pending: "bg-mark-important",
  error: "bg-mark-critical",
  stale: "bg-muted-foreground",
};

// ---------------------------------------------------------------------------
// SourceStatusBadge — renders a Badge with the right color for a status
// ---------------------------------------------------------------------------

interface SourceStatusBadgeProps {
  status: string;
  className?: string;
}

export function SourceStatusBadge({
  status,
  className,
}: SourceStatusBadgeProps) {
  return (
    <Badge
      variant="secondary"
      className={`${statusColors[status] ?? ""} ${className ?? ""}`}
    >
      {statusLabels[status] ?? status}
    </Badge>
  );
}
